module.exports = __webpack_public_path__ + "img/arty3.0e559b60.png";